const getters = {
  isSupervision: state => state.permission.isSupervision,
  getRoles: state => state.permission.roles,
  superviseRole: state => ['h', 'i', 'j'].some(v => state.permission.roleType.includes(v)), // 监管账号
  roleType: state => state.permission.roleType, // 获取角色前端需要角色类型
  addRoutes: state => state.permission.addRoutes, // 根据权限得到筛选后的路由
  keepAlive: state => state.global.keepAlive, // 需要keepalive的路由
  permission_routes: state => state.permission.routes,
  supervision_routes: state => state.permission.sr,
  punchOn: state => state.global.userInfo.punchOn,
  serviceTypes: state => state.global.userInfo.serviceTypes,
  punchState: state => state.global.punchState,
  userName: state => state.global.userName, // 获取用户名
  userId: state => state.global.userId, // 获取用户id
  ucUserId: state => state.global.ucUserId, // 获取用户中心用户id
  isChain: state => state.global.isChain, // 是否连锁药店,1是，0-不是
  storeAccoutnInfo: st => st.global.storeAccoutnInfo, // 获取店铺账户信息
  notification: state => state.global.notification, // 获取通知框展示状态
  onlineStatus: state => state.global.onlineStatus, // 用户在线离线状态
  companyId: state => state.global.companyId, // 获取公司Id
  companyName: state => state.global.companyName, // 获取公司名
  roleListFromBk: state => state.global.roleListFromBk, // 获取从后台拿来的角色列表
  storeList: state => state.global.storeList, // 获取当前账号下的药店列表
  roleStore: state => state.global.roleStore, // 获取角色下的药店
  store_managerStoreInfo: state => state.global.store_managerStoreInfo, // 获取店长店铺数据
  refusedStoreList: state => state.global.refusedStoreList, // 获取当前账号被驳回的的药店列表
  getdisplayConfig: state => state.global.displayConfig, // 获取当前配置文件
  warnState: state => state.global.warnState, // 当前警告框是否弹出
  getShopManagementMode: state => state.shopManagement.mode, // 获取门店管理当前的模式类型
  getchangeSetingList: state => state.shopManagement.changeSetingList, // 获取shopManagement修改List
  visitedViews: state => state.tagsView.visitedViews, // 获取看过列表
  cachedViews: state => state.tagsView.cachedViews, // 获取看过列表
  fileDomain: state => state.global.fileDomain, // 获取资源头
  ifFresh: state => state.prescription.ifFreshPrescriptionList, // 处方列表是否刷新标志
  prescriptionSearchData: state => state.prescription.prescriptionSearchData, // 处方列表搜索数据
  messageCenterList: state => state.messageCenter.messageCenterList, // 消息中心列表
  messageCenterNotification: state => state.messageCenter.messageCenterNotification, // 获取是否有未读消息
  activityId: state => state.activity.activityId, // 活动ID
  activityAlive: state => state.activity.status === '1' || state.activity.status === 1, // 活动状态 0-下架，1-上架
  activityInit: state => state.activity.init, // 活动信息是否初始化，未初始化则需重新调用
  resourcePutObj: state => state.activity.resourcePutObj, // 资源投放对象
  storeConfig: state => state.global.storeConfig // 门店白名单配置
};
export default getters;
